import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { MBAPL_FINANCIAL_API } from "./apiRoutes";

const mutateAddMbaplFinancialReporting = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${MBAPL_FINANCIAL_API}/`, data);
};

const useAddMbaplFinancialReportingMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddMbaplFinancialReporting,
    ...queryParams,
  });

export default useAddMbaplFinancialReportingMutation;
